import { useContext } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { GlobalContext } from '../../../services/context/DataContext'
import {
  useDispatch,
  GlobalFeatureNameSpaceNotary
} from '../../../common/redux.Interface.Component'
import { createAction } from '../../../common/redux.Interface.Reducer'

const ContactInfoMenuItem = ({
  minimizeMenu,
  setOptionsMenu,
  text,
  image,
  linkTo
}) => {
  const classes = useStyles({ minimizeMenu })
  const { activeTabData } = useContext(GlobalContext)
  const [, setActiveTab] = activeTabData
  const dispatch = useDispatch()
  const doDispatch = () => {
    dispatch(
      createAction(GlobalFeatureNameSpaceNotary.SIGNIN_SIGNOUT, 'signOut')()
    )
  }

  const getImageAltText = () =>
    text.replace(/[\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/g, '')

  const handleClick = () => {
    console.log(linkTo)
    setOptionsMenu((prev) => !prev)

    linkTo !== 'signOut' ? setActiveTab(linkTo) : doDispatch()
  }

  return (
    <div className={classes.root} onClick={handleClick}>
      <img
        className={classes.optionsMenuItemImage}
        src={image}
        alt={getImageAltText()}
      />
      {!minimizeMenu && text}
    </div>
  )
}

export default ContactInfoMenuItem

const useStyles = makeStyles((theme, props) => ({
  root: {
    width: '100%',
    height: '50%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    ...theme.typography.h3,
    borderBottom: `1px solid ${theme.palette.quaternary.accent}`,
    padding: '3px 20px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  optionsMenuItemImage: {
    boxSizing: 'border-box',
    width: '25px',
    padding: '3px',
    marginRight: '10px'
  }
}))
